export default function (string) {
	return string.replace(/\/$/, '')
}
